import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Crud, CrudService } from '../../../core';
import { ItemGrupo } from './item-grupo';

@Injectable({
    providedIn: 'root'
})
export class ItemGrupoCrudHttpService implements Crud<ItemGrupo> {
    resource = 'itemgrupo';

    constructor(private crudService: CrudService) { }

    search(): Observable<ItemGrupo[]> {
        return this.crudService.search<ItemGrupo>(this.resource);
    }

    find(id: number): Observable<ItemGrupo> {
        return this.crudService.find<ItemGrupo>(this.resource, id);
    }

    load(id: number): Observable<ItemGrupo> {
        return this.crudService.load<ItemGrupo>(this.resource, id)
            .pipe(
                map(itemGrupo => {
                    itemGrupo?.classificacoes?.forEach(classificacao => {
                        classificacao.canEdit = true;
                        classificacao.obrigatorio = false;
                    });

                    return itemGrupo;
                })
            );
    }

    insert(entity: ItemGrupo): Observable<ItemGrupo> {
        return this.crudService.insert<ItemGrupo>(this.resource, entity);
    }

    update(entity: ItemGrupo): Observable<ItemGrupo> {
        return this.crudService.update<ItemGrupo>(this.resource, entity);
    }

    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
